<template>
  <div class="ListingsPage">
    <div class="flex">
      <SideFilter class="ListingsPage__side-filter" :class="$mq" :listingsCount="listingsCount" />
      <section class="flex-grow min-w-0 sm:ml-8 mt-6 md:mt-10">
        <div class="flex flex-row justify-between items-end hidden sm:flex">
          <HeaderTitle :longtail="longtail" :competition="competition" />
          <div class="flex self-start shrink-0">
            <CategorySelector />
            <PrizeCategorySelector :categories="prizeCategories(true)" />
            <SortBy />
          </div>
        </div>
        <div
          v-if="$mq === 'xs'"
          class="z-10 flex items-start md:items-center justify-between bg-white flex-col md:flex-row"
        >
          <HeaderTitle :longtail="longtail" :competition="competition" />
        </div>
        <MobileFilter
          class="sm:border-b border-grey-light py-4 sticky"
          :prizeCategories="prizeCategories()"
          v-if="$mq === 'xs'"
        />
        <ListingPagination
          :per-page="per"
          :price-filter-applied="priceFilterApplied"
          :size-filter-applied="sizeFilterApplied"
          :guest-favourites="guestFavourites"
          class="mb-24"
        />
        <CollectionInformation class="mt-6" :filterData="filterData" />
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"

import UrlFilterBuilder from "@/lib/Listing/UrlFilterBuilder"
import HeaderTitle from "./HeaderTitle.vue"
import SortBy from "./SortBy.vue"
import CategorySelector from "./CategorySelector.vue"
import PrizeCategorySelector from "./PrizeCategorySelector.vue"
import ListingPagination from "./ListingPagination.vue"
import MobileFilter from "./filters/mobile/MobileFilter.vue"
import SideFilter from "./filters/SideFilter.vue"
import CollectionInformation from "./CollectionInformation.vue"

import CURRENT_QUERY from "@/queries/Current.query.gql"

export default {
  name: "ListingsPage",
  props: ["filterData", "longtail", "competition", "isArtist", "guestFavourites"],
  mounted() {
    this.setUserArtist(this.isArtist)
    const filters = UrlFilterBuilder(window.location)
    filters["longtail_id"] = this.longtail.id
    this.setConfig(this.filterData)
    this.initListings(filters)
    window.dispatchEvent(new Event("listings-page-mounted"))
  },
  apollo: {
    currentUser: {
      query: CURRENT_QUERY,
    },
  },
  methods: {
    prizeCategories(withAllOption = false) {
      const baseOptions = withAllOption ? [{ title: "Prize categories", value: "all" }] : []
      if (this.isAdmin && this.competition.slug) return baseOptions.concat(this.prizeCategoriesMap)
      return []
    },
    ...mapActions("filter", ["setUserArtist", "initListings", "setConfig"]),
  },
  computed: {
    prizeCategoriesMap() {
      return this.competition.categories.map((category) => ({ title: category.title, value: category.id }))
    },
    isAdmin() {
      return this.currentUser && this.currentUser.admin
    },
    priceFilterApplied() {
      return this.prices.length > 0 || this.priceRange.length > 0
    },
    sizeFilterApplied() {
      return this.sizes.length > 0 || this.width.length > 0 || this.height.length > 0
    },
    ...mapState("filter", {
      per: (state) => state.filters.per,
      listingsCount: (state) => state.listings_count,
      prices: (state) => state.filters.prices,
      priceRange: (state) => state.filters.price_range,
      sizes: (state) => state.filters.sizes,
      width: (state) => state.filters.width,
      height: (state) => state.filters.height,
    }),
  },
  components: {
    HeaderTitle,
    CategorySelector,
    SortBy,
    SideFilter,
    MobileFilter,
    ListingPagination,
    CollectionInformation,
    PrizeCategorySelector,
  },
}
</script>

<style lang="scss" scoped>
.ListingsPage__side-filter {
  @apply grow-0 shrink-0 pt-6;
  overflow-y: scroll;
  position: sticky;
  top: 60px;
  bottom: 0px;
  height: calc(100vh - 60px);

  &.xs {
    display: none;
  }

  &.sm {
    min-width: 30%;
    width: 34%;
  }

  &.md,
  &.lg {
    min-width: 290px;
    width: 290px;
    top: 105px;
    height: calc(100vh - 105px);
  }
}

.ListingsPage__side-filter {
  @apply pr-8;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
    background-color: rgba(0, 0, 0, 0.03);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>
